import { render, staticRenderFns } from "./SegContrato.vue?vue&type=template&id=6c4045b7&scoped=true&"
import script from "./SegContrato.vue?vue&type=script&lang=js&"
export * from "./SegContrato.vue?vue&type=script&lang=js&"
import style0 from "./SegContrato.vue?vue&type=style&index=0&id=6c4045b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4045b7",
  null
  
)

export default component.exports